





















































































































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop, Watch, Vue} from 'vue-property-decorator';

import {Notify} from '@/utils/Notify';

import {LoraPacketType} from '@/model/lora/LoraPacket/LoraPacketType';
import {LoraPacket} from '@/model/lora/LoraPacket/LoraPacket';
import {LoraPacketUplink} from '@/model/lora/LoraPacket/LoraPacketUplink';
import {LoraPacketUplinkData} from '@/model/lora/LoraPacket/LoraPacketUplinkData';
import {LoraMessageType} from '@/model/lora/LoraPacket/LoraMessageType';

import {LoraForwarderStore} from '@/store/lora/LoraForwarder.store';

import {BaseComponent} from '@/mixins/BaseComponent';
import {LoraPacketUplinkJoinRequest} from '@/model/lora/LoraPacket/LoraPacketUplinkJoinRequest';

@Component({
  components: {},
})
export default class LoraForwarderPacket extends Mixins<BaseComponent>(BaseComponent) {
  private LoraPacketType = LoraPacketType;

  @Prop(Object)
  private forwarderStore!: LoraForwarderStore;

  private autoScroll: boolean = false;

  @Prop({default: false})
  private loadExpanded?: boolean;

  @Prop({default: false})
  private lorawanUnavailable?: boolean;

  private expanded: boolean = false;

  private get headers(): any {

    let headers = [
      {text: 'Time', value: 'Time', sortable: true},
      {text: 'Direction', value: 'Type'},
    ];

    if (!this.lorawanUnavailable) {
      headers = headers.concat([
        {text: 'Message type', value: 'MessageType'},
        {text: 'Device EUI/address', value: 'DeviceAddress', sortable: false},
      ]);
    }

    headers = headers.concat([
      {text: 'Frequency', value: 'TxInfo.Frequency'},
      {text: 'Datarate', value: 'TxInfo.Datarate', sortable: false},
      {text: 'Size', value: 'Size'},
      {text: 'RSSI', value: 'RxInfo.RSSI'},
      {text: 'SNR', value: 'RxInfo.LoraSNR'},
    ]);

    return headers;
  }

  private async mounted() {

    if (this.loadExpanded !== undefined) {
      this.expanded = this.loadExpanded;
    }

    this.subscribeScrollListener();
    await this.subscribePackets();
    this.autoScroll = true;
    this.scrollDown();
  }

  private async beforeDestroy() {
    this.unsubscribeScrollListener();
    await this.forwarderStore.unsubscribePackets();
  }

  private async subscribePackets() {
    try {
      this.logger.debug(`Subscribing to forwarder packets`);
      await this.forwarderStore.subscribePackets();
    } catch (error) {
      Notify.Warn(this.logger, `Could not subscribe to forwarder packets`, error);
    }
  }

  @Watch('forwarderStore.Packets')
  private scrollDown() {
    if (this.autoScroll) {
      const content = document.querySelector('#packet-table div');

      if (content) {
        Vue.nextTick(() => {
          content.scrollTop = content.scrollHeight;
        });
      }
    }
  }

  private autoScrollClick() {
    this.autoScroll = !this.autoScroll;
    this.scrollDown();
  }

  private subscribeScrollListener() {
    const content = document.querySelector('#packet-table div');

    if (content) {
      content.addEventListener('scroll', this.scrollListener);
    }
  }

  private unsubscribeScrollListener() {
    const content = document.querySelector('#packet-table div');

    if (content) {
      content.removeEventListener('scroll', this.scrollListener);
    }
  }

  private scrollListener() {
    const content = document.querySelector('#packet-table div');

    if (content) {
      this.autoScroll = content.scrollTop + content.clientHeight >= content.scrollHeight;
    }
  }

  private MessageType(packet: LoraPacket) {

    switch ((packet as LoraPacket).MessageType) {
      case LoraMessageType.Unknown:
        return 'Unknown';
      case LoraMessageType.JoinRequest:
        return 'Join request';
      case LoraMessageType.JoinAccept:
        return 'Join accept';
      case LoraMessageType.UnconfirmedDataUp:
        return 'Data (unconfirmed)';
      case LoraMessageType.ConfirmedDataUp:
        return 'Data (confirmed)';
      case LoraMessageType.RejoinRequest:
        return 'Rejoin request';
      case LoraMessageType.Proprietary:
        return 'Proprietary';
    }
  }

  private DeviceAddress(packet: LoraPacket) {

    if (packet instanceof LoraPacketUplinkData) {
      return (packet as LoraPacketUplinkData).DeviceAddress;
    } else if (packet instanceof LoraPacketUplinkJoinRequest) {
      return (packet as LoraPacketUplinkJoinRequest).DeviceEUI;
    }
  }

  private PacketDirectionIcon(type: LoraPacketType): string {
    switch (type) {
      case LoraPacketType.Downlink:
        return 'mdi-arrow-down-bold';
      case LoraPacketType.Uplink:
        return 'mdi-arrow-up-bold';
      default:
        return '';
    }
  }

  private SignalStrengthIcon(strength: number): any {
    if (strength < -120) {
      return {
        icon: 'mdi-signal-cellular-outline',
        color: 'red',
      };
    } else if (strength < -110) {
      return {
        icon: 'mdi-signal-cellular-1',
        color: 'orange',
      };
    } else if (strength < -100) {
      return {
        icon: 'mdi-signal-cellular-2',
        color: 'green',
      };
    } else {
      return {
        icon: 'mdi-signal-cellular-3',
        color: 'green',
      };
    }
  }

  private NoiseIcon(snr: number): any {
    if (snr > 3) {
      return {
        icon: 'mdi-volume-low',
        color: 'green',
      };
    } else if (snr > -3) {
      return {
        icon: 'mdi-volume-medium',
        color: 'orange',
      };
    } else {
      return {
        icon: 'mdi-volume-high',
        color: 'red',
      };
    }
  }
}
